import SchemaOrg from '@/components/base/SchemaOrg';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import AdvantagesSection from './components/AdvantagesSection';
import HighlightsSection from './components/HighlightsSection';
import TestimonialsSection from './components/TestimonialsSection';
import FaqSection from './components/FaqSection';
import CtaSection from './components/CtaSection';

export default function Home() {
  return (
    <>
      <SchemaOrg />
      <main>
        <HeroSection />
        <FeaturesSection />
        <AdvantagesSection />
        <HighlightsSection />
        <TestimonialsSection />
        <FaqSection />
        <CtaSection />
      </main>
    </>
  );
}